import SlimSelect from 'slim-select';
import { DEVICE_WIDTH } from '../../../utils/viewport-width';
import PageHandlersService from '@/utils/page-handlers-service';
import phoneModalTimer from '@/utils/phone-code';
import axios from 'axios';
import createValidator from '@/modules/validator';
import ajaxForms from '@/inits/ajax-forms';
import { openDynamicBanner } from '@/components/dynamic-banner';

type TFieldType = 'email' | 'phone' | 'birthday' | 'password' | 'address' | 'card' | undefined;

let fields: HTMLElement[];

const pageHandlers = new PageHandlersService();
const changePhoneModal = document.querySelector('.js-ps-change-phone-modal') as HTMLFormElement;
const displayTextContainer = changePhoneModal.querySelector('.js-ps-change-phone-new-value');
const oldPhoneNumberContainer = document.querySelector('.js-ps-phone-field');
const mailContainer = document.querySelector('.js-ps-email-field');
const mailValue = mailContainer?.querySelector<HTMLElement>('.js-ps-field-value')?.innerText;
const oldPhoneNumberValue = oldPhoneNumberContainer?.querySelector<HTMLElement>('.js-ps-field-value')?.innerText;
const phoneNumberInput = document.querySelector<HTMLInputElement>('.js-intl-phone');
let hideTimeout: NodeJS.Timeout;
let retryTimeout: NodeJS.Timeout | null = null;

const handleAddressCloseExtensionClosure = (collapseElement: HTMLElement) => () => {
    if (window.innerWidth > 1365) {
        collapseElement.style.height = '47px';
    } else if (DEVICE_WIDTH.isDesktop) {
        collapseElement.style.height = '32px';
    } else if (DEVICE_WIDTH.isTablet) {
        collapseElement.style.height = '48px';
    } else {
        collapseElement.style.height = '86px';
    }
};

const fieldInputChangeHandlers = (field: HTMLElement) => {
    const fieldInputs = Array.from(field.querySelectorAll<HTMLElement>('.js-ps-field-input'));

    fieldInputs.forEach((input) => {
        const inputValueName = input.dataset.valueName;

        if (inputValueName) {
            const valueElement = field.querySelector(`.js-ps-field-value[data-value-name=${inputValueName}]`);

            pageHandlers.set(
                input,
                (event) => {
                    const newValue = (event.target as HTMLInputElement).value;

                    if (valueElement) {
                        valueElement.innerHTML = newValue;
                    }
                },
                'change',
            );
        }
    });
};

function confirmNumber() {
    const displayText = `Мы отправили вам пуш-уведомление на номер ${oldPhoneNumberValue}.
    Подтвердите (примите) его пожалуйста. Либо перейдите по ссылке в SMS для подтверждения действия.`;
    if (displayTextContainer) {
        displayTextContainer.innerHTML = displayText;
    }
    const newPhoneNumber = phoneNumberInput?.value;
    if (newPhoneNumber && oldPhoneNumberValue) {
        const requestBody = {
            params: {
                params: {
                    phone: newPhoneNumber,
                    old_phone: oldPhoneNumberValue,
                    email: mailValue,
                    action: 'changePhone',
                },
            },
        };
        axios.get('/local/ajax/mobileId.php', requestBody).then((response) => {
            if (response.data.success && response.data.data.action) {
                changeNumber(newPhoneNumber, oldPhoneNumberValue, response.data.data.action, response.data.data.method);
            } else {
                openDynamicBanner(response.data.message);
            }
        });
    }
}

function changeNumber(newPhone: string, oldPhone: string, action: string, method: string) {
    const requestBody = {
        params: {
            params: {
                action: action,
                method: method,
                phone: newPhone,
                old_phone: oldPhone,
            },
        },
    };

    if (retryTimeout) {
        clearTimeout(retryTimeout);
    }

    axios
        .get('/local/ajax/mobileId.php', requestBody)
        .then((response) => {
            if (response.data.success) {
                clearTimeout(hideTimeout);
                ajaxForms.showFormMessages(changePhoneModal);
                hideTimeout = setTimeout(() => ajaxForms.hideFormMessages(changePhoneModal), 5000);
                ajaxForms.showSuccessMessage(changePhoneModal, response.data.message);
                window.location.reload();
            } else {
                retryTimeout = setTimeout(() => {
                    changeNumber(newPhone, oldPhone, action, method);
                }, 5000);
            }
        })
        .catch((error) => {
            console.error('Ошибка:', error);
            ajaxForms.showFailureMessage(changePhoneModal, 'Произошла ошибка при отправке формы');
        });
}

const init = () => {
    fields = Array.from(document.querySelectorAll<HTMLElement>('.js-ps-field'));

    const handleCloseFields = () => {
        fields.forEach((field) => {
            const collapseElement = field.querySelector<HTMLElement>('.js-ps-field-collapse');
            const editButton = field.querySelector('.js-ps-field-edit');
            const cancelButton = field.querySelector<HTMLButtonElement>('.js-ps-field-cancel');

            if (collapseElement && cancelButton) {
                collapseElement.style.height = '0px';

                const collapseInteractiveElements = [
                    ...Array.from(
                        collapseElement.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input'),
                    ),
                    cancelButton,
                ];

                collapseInteractiveElements.forEach((element) => {
                    element.tabIndex = -1;
                });
            }

            editButton?.classList.remove('disabled');
            cancelButton?.classList.add('disabled');
            field.classList.remove('active');
        });
    };

    fields.forEach((field) => {
        // Переиспользуемая логика для всех аккордионов
        const fieldType = field.dataset.type as TFieldType;

        const collapseElement = field.querySelector<HTMLElement>('.js-ps-field-collapse');
        const editButton = field.querySelector('.js-ps-field-edit');
        const cancelButton = field.querySelector<HTMLButtonElement>('.js-ps-field-cancel');

        fieldInputChangeHandlers(field);

        const handleOpenModalClosure = (modal: Element, extensionCallback?: () => void) => async () => {
            phoneModalTimer.timerStop();
            await confirmNumber();
            if (modal) {
                extensionCallback?.();

                modal.classList.add('active');
                const popupsInteractiveElements = Array.from(
                    modal.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input'),
                );

                popupsInteractiveElements.forEach((element) => {
                    element.tabIndex = 0;
                });
            }
        };

        const handleCloseModalClosure = (modal: Element, extensionCallback?: () => void) => () => {
            if (modal) {
                extensionCallback?.();

                modal.classList.remove('active');
                phoneModalTimer.timerStop();

                const interactiveElements = Array.from(
                    modal.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input'),
                );

                interactiveElements.forEach((element) => {
                    element.tabIndex = -1;
                });
            }
        };

        // save changes
        const saveChangesBtn = field.querySelector<HTMLButtonElement>('.js-ps-field__submit');
        const savePersonalSettings = () => {
            handleCloseFields();
        };
        pageHandlers.set(saveChangesBtn, savePersonalSettings);

        if (collapseElement && cancelButton && editButton) {
            const collapseInteractiveElements = [
                ...Array.from(collapseElement.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input')),
                cancelButton,
            ];

            collapseInteractiveElements.forEach((element) => {
                element.tabIndex = -1;
            });

            // Замыкание логики открытия и закрытия аккордионов
            const handleEditClosure = (typeExtensionCallback?: () => void) => () => {
                handleCloseFields();

                collapseElement.style.height = `${collapseElement.scrollHeight}px`;

                editButton.classList.add('disabled');
                cancelButton.classList.remove('disabled');
                field.classList.add('active');

                collapseInteractiveElements.forEach((element) => {
                    element.tabIndex = 0;
                });

                typeExtensionCallback?.();
            };

            const handleCloseClosure = (typeExtensionCallback?: () => void) => () => {
                collapseElement.style.height = '0px';

                editButton.classList.remove('disabled');
                cancelButton.classList.add('disabled');
                field.classList.remove('active');

                collapseInteractiveElements.forEach((element) => {
                    element.tabIndex = -1;
                });

                typeExtensionCallback?.();
            };

            // Логика аккордионов по типам
            if (!fieldType) {
                const inputElement = field.querySelector<HTMLInputElement>('.js-ps-field-input');
                const valueElement = field.querySelector<HTMLElement>('.js-ps-field-value');

                if (inputElement && valueElement) {
                    const handleEdit = handleEditClosure();
                    const handleClose = handleCloseClosure();

                    pageHandlers.set(editButton, handleEdit);
                    pageHandlers.set(cancelButton, handleClose);
                }
            }

            if (fieldType === 'phone') {
                const inputElement = field.querySelector<HTMLInputElement>('.js-ps-field-input');
                const valueElement = field.querySelector<HTMLElement>('.js-ps-field-value');

                const changePhoneModal = document.querySelector('.js-ps-change-phone-modal');
                const changePhoneModalCloseElements = document.querySelectorAll('.js-ps-change-phone-modal-close');
                const phoneModalBtn = document.querySelector('.js-ps-phone-change');

                if (inputElement && valueElement && changePhoneModal) {
                    const handleEdit = handleEditClosure();
                    const handleClose = handleCloseClosure();

                    const handleOpenModal = handleOpenModalClosure(changePhoneModal);
                    const handleCloseModal = handleCloseModalClosure(changePhoneModal);

                    pageHandlers.set(editButton, handleEdit);
                    pageHandlers.set(cancelButton, handleClose);
                    pageHandlers.set(phoneModalBtn, () => {
                        const phoneField = document.querySelector('.js-ps-phone-field');
                        const validator = createValidator(phoneField as HTMLFormElement, {
                            scrollToInvalidInputOptions: {
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'center',
                            },
                        });
                        const isFormValid = validator.validate();
                        if (isFormValid) {
                            handleOpenModal();
                        }
                    });

                    changePhoneModalCloseElements.forEach((element) => {
                        pageHandlers.set(element, handleCloseModal);
                    });
                }
            }

            if (fieldType === 'email') {
                const inputElement = field.querySelector<HTMLInputElement>('.js-ps-field-input');
                const valueElement = field.querySelector<HTMLElement>('.js-ps-field-value');

                const removeEmailModal = document.querySelector('.js-ps-change-email-modal');
                const removeEmailModalCloseElements = document.querySelectorAll('.js-ps-change-email-modal-close');

                if (inputElement && valueElement && removeEmailModal) {
                    const handleEdit = handleEditClosure();
                    const handleClose = handleCloseClosure();

                    const handleOpenModal = handleOpenModalClosure(removeEmailModal);
                    const handleCloseModal = handleCloseModalClosure(removeEmailModal);

                    pageHandlers.set(editButton, handleEdit);
                    pageHandlers.set(cancelButton, handleClose);

                    removeEmailModalCloseElements.forEach((element) => {
                        pageHandlers.set(element, handleCloseModal);
                    });
                }

                if (removeEmailModal) {
                }
            }

            if (fieldType === 'birthday') {
                const dayInputElement = field.querySelector<HTMLInputElement>('.js-ps-field-day-input');
                const dayValueElement = field.querySelector<HTMLElement>('.js-ps-field-day-value');
                const monthInputElement = field.querySelector<HTMLInputElement>('.js-ps-field-month-input');
                const monthValueElement = field.querySelector<HTMLElement>('.js-ps-field-month-value');
                const yearInputElement = field.querySelector<HTMLInputElement>('.js-ps-field-year-input');
                const yearValueElement = field.querySelector<HTMLElement>('.js-ps-field-year-value');

                const monthSelectDecors = field.querySelector('.js-ps-birthday-month-decors');
                const selectArrow = field.querySelector('.js-select-arrow');

                if (
                    dayInputElement &&
                    dayValueElement &&
                    monthInputElement &&
                    monthValueElement &&
                    yearInputElement &&
                    yearValueElement &&
                    monthSelectDecors &&
                    selectArrow
                ) {
                    let setOverflowTimeout: NodeJS.Timeout;

                    const handleSelectFocus = () => {
                        monthSelectDecors.classList.add('active');
                        selectArrow.classList.add('active');

                        const selectContent = field.querySelector<HTMLElement>('.ss-content');

                        if (selectContent) {
                            selectContent.style.height = `${selectContent.scrollHeight}px`;
                        }
                    };

                    const handleSelectBlur = () => {
                        monthSelectDecors.classList.remove('active');
                        selectArrow.classList.remove('active');

                        const selectContent = field.querySelector<HTMLElement>('.ss-content');

                        if (selectContent) {
                            selectContent.style.height = '0px';
                        }
                    };

                    const monthSelect = new SlimSelect({
                        select: monthInputElement,
                        showSearch: false,
                        searchFocus: false,
                        beforeOpen: handleSelectFocus,
                        beforeClose: handleSelectBlur,
                    });

                    const handleEditExtension = () => {
                        dayInputElement.value = dayValueElement.innerText;
                        monthSelect.set(monthValueElement.innerText.toLowerCase());
                        yearInputElement.value = yearValueElement.innerText;

                        setOverflowTimeout = setTimeout(() => {
                            collapseElement.style.overflow = 'visible';
                        }, 400);
                    };

                    const handleCloseExtension = () => {
                        collapseElement.style.overflow = 'hidden';

                        if (setOverflowTimeout) {
                            clearTimeout(setOverflowTimeout);
                        }

                        monthSelect.close();
                    };

                    const handleEdit = handleEditClosure(handleEditExtension);
                    const handleClose = handleCloseClosure(handleCloseExtension);

                    pageHandlers.set(editButton, handleEdit);
                    pageHandlers.set(cancelButton, handleClose);

                    pageHandlers.addDestroy(() => {
                        monthSelect.destroy();
                    });
                }
            }

            if (fieldType === 'password') {
                const handleEdit = handleEditClosure();
                const handleClose = handleCloseClosure();

                pageHandlers.set(editButton, handleEdit);
                pageHandlers.set(cancelButton, handleClose);
            }

            if (fieldType === 'address') {
                const handleEdit = handleEditClosure();
                const handleClose = handleCloseClosure(handleAddressCloseExtensionClosure(collapseElement));

                pageHandlers.set(editButton, handleEdit);
                pageHandlers.set(cancelButton, handleClose);
            }
        }
    });

    // Phone submit form
    const phoneSubmitInputs = document.querySelectorAll<HTMLInputElement>('.js-ps-change-phone-code-input');

    phoneSubmitInputs.forEach((input, inputIndex) => {
        let isInputFocused = false;

        const handleInputFocus = () => (isInputFocused = true);
        const handleInputBlur = () => (isInputFocused = false);

        const handlePhoneSubmitInputChange = () => {
            // clear not numeric enter
            if (input && isNaN(+input.value)) {
                input.value = '';
            }

            if (input.value) {
                if (inputIndex !== 3) {
                    phoneSubmitInputs[inputIndex + 1].focus();
                }
            }
        };

        const handlePhoneSubmitInputKeypress = (event: KeyboardEvent) => {
            if (isInputFocused && event.code === 'Backspace') {
                if (inputIndex !== 0) {
                    phoneSubmitInputs[inputIndex - 1].focus();
                }
            }
        };

        pageHandlers.set(input, handlePhoneSubmitInputChange, 'input');
        pageHandlers.set(input, handlePhoneSubmitInputKeypress, 'keyup');
        pageHandlers.set(input, handleInputFocus, 'focus');
        pageHandlers.set(input, handleInputBlur, 'blur');
    });

    const phoneField = document.querySelector('.js-ps-phone-field');

    if (phoneField) {
        const collapseElement = phoneField.querySelector<HTMLElement>('.js-ps-field-collapse');
        const editButton = phoneField.querySelector('.js-ps-field-edit');
        const cancelButton = phoneField.querySelector<HTMLButtonElement>('.js-ps-field-cancel');

        const inputElement = phoneField.querySelector<HTMLInputElement>('.js-ps-field-input');
        const valueElement = phoneField.querySelector<HTMLElement>('.js-ps-field-value');

        const resetNumberButton = document.querySelector('.js-ps-change-phone-reset-btn');
        const changePhoneModal = document.querySelector('.js-ps-change-phone-modal');

        if (
            collapseElement &&
            cancelButton &&
            editButton &&
            inputElement &&
            valueElement &&
            resetNumberButton &&
            changePhoneModal
        ) {
            const collapseInteractiveElements = [
                ...Array.from(collapseElement.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input')),
                cancelButton,
            ];

            collapseInteractiveElements.forEach((element) => {
                element.tabIndex = -1;
            });

            const handleResetNumber = () => {
                // Phone editing
                inputElement.value = valueElement.innerText;

                collapseElement.style.height = `${collapseElement.scrollHeight}px`;

                editButton.classList.add('disabled');
                cancelButton.classList.remove('disabled');
                phoneField.classList.add('active');

                collapseInteractiveElements.forEach((element) => {
                    element.tabIndex = 0;
                });

                // Close modal
                changePhoneModal.classList.remove('active');

                const popupInteractiveElements = Array.from(
                    changePhoneModal.querySelectorAll<HTMLButtonElement | HTMLInputElement>('button, input'),
                );

                popupInteractiveElements.forEach((element) => {
                    element.tabIndex = 0;
                });
            };

            pageHandlers.set(resetNumberButton, handleResetNumber);
        }
    }

    const dayInputElement = document.querySelector<HTMLInputElement>('.js-ps-field-day-input');
    const monthInputElement = document.querySelector<HTMLInputElement>('.js-ps-field-month-input');
    const yearInputElement = document.querySelector<HTMLInputElement>('.js-ps-field-year-input');
    const dayValueElement = document.querySelector<HTMLElement>('.js-ps-field-day-value');
    const monthValueElement = document.querySelector<HTMLElement>('.js-ps-field-month-value');
    const yearValueElement = document.querySelector<HTMLElement>('.js-ps-field-year-value');
    const finalDateInputElement = document.querySelector<HTMLInputElement>('.js-date-input');

    if (
        dayInputElement &&
        monthInputElement &&
        yearInputElement &&
        finalDateInputElement &&
        dayValueElement &&
        monthValueElement &&
        yearValueElement
    ) {
        const handleDayInputChange = () => {
            const finalDateValueElements = finalDateInputElement.value.split('.');

            finalDateInputElement.value = `${dayInputElement.value.padStart(2, '0')}.${finalDateValueElements[1]}.${
                finalDateValueElements[2]
            }`;
        };

        const handleMonthInputChange = () => {
            let monthIndex;

            switch (monthInputElement.value.toLowerCase()) {
                case 'января':
                    monthIndex = '01';
                    break;
                case 'февраля':
                    monthIndex = '02';
                    break;
                case 'марта':
                    monthIndex = '03';
                    break;
                case 'апреля':
                    monthIndex = '04';
                    break;
                case 'мая':
                    monthIndex = '05';
                    break;
                case 'июня':
                    monthIndex = '06';
                    break;
                case 'июля':
                    monthIndex = '07';
                    break;
                case 'августа':
                    monthIndex = '08';
                    break;
                case 'сентября':
                    monthIndex = '09';
                    break;
                case 'октября':
                    monthIndex = '10';
                    break;
                case 'ноября':
                    monthIndex = '11';
                    break;
                case 'декабря':
                    monthIndex = '12';
                    break;
                default:
                    monthIndex = '01';
                    break;
            }

            const finalDateValueElements = finalDateInputElement.value.split('.');

            finalDateInputElement.value = `${finalDateValueElements[0]}.${monthIndex}.${finalDateValueElements[2]}`;
        };

        const handleYearInputChange = () => {
            const finalDateValueElements = finalDateInputElement.value.split('.');

            finalDateInputElement.value = `${finalDateValueElements[0]}.${finalDateValueElements[1]}.${yearInputElement.value}`;
        };

        const handleDateInit = () => {
            const finalDateValueElements = finalDateInputElement.value.split('.');
            let monthValue;
            console;

            switch (+finalDateValueElements[1]) {
                case 1:
                    monthValue = 'января';
                    break;
                case 2:
                    monthValue = 'февраля';
                    break;
                case 3:
                    monthValue = 'марта';
                    break;
                case 4:
                    monthValue = 'апреля';
                    break;
                case 5:
                    monthValue = 'мая';
                    break;
                case 6:
                    monthValue = 'июня';
                    break;
                case 7:
                    monthValue = 'июля';
                    break;
                case 8:
                    monthValue = 'августа';
                    break;
                case 9:
                    monthValue = 'сентября';
                    break;
                case 10:
                    monthValue = 'октября';
                    break;
                case 11:
                    monthValue = 'ноября';
                    break;
                case 12:
                    monthValue = 'декабря';
                    break;
                default:
                    monthValue = 'января';
                    break;
            }

            dayInputElement.value = `${+finalDateValueElements[0]}`;
            dayValueElement.innerText = `${+finalDateValueElements[0]}`;
            yearInputElement.value = finalDateValueElements[2];
            yearValueElement.innerText = finalDateValueElements[2];
            monthInputElement.value = monthValue;
            monthValueElement.innerText = monthValue;
        };

        handleDateInit();

        pageHandlers.set(dayInputElement, handleDayInputChange, 'change');
        pageHandlers.set(monthInputElement, handleMonthInputChange, 'change');
        pageHandlers.set(yearInputElement, handleYearInputChange, 'change');
    }
};

const destroy = () => {
    pageHandlers.clear();
};

const _module = { init, destroy };

export default _module;
